import { Component, OnInit } from '@angular/core';

import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {StoreService} from '../../store.service';
import { utils } from 'protractor';
import { UtilitiesService } from 'src/app/core/utilities.service';

const DEFAULT_DURATION = 250;

@Component({
  selector: 'app-faq2',
  templateUrl: './faq2.component.html',
  styleUrls: ['./faq2.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class Faq2Component implements OnInit {

  records = [];
  categoryCount = 0;
  questionAnswerCount = [];
  answer = [];
  loading = true;

  constructor(
      private svc: StoreService,
      public utils: UtilitiesService
  ) {}

  ngOnInit() {
      const token = localStorage.getItem('bearer');
      const category = 'general,online';
      this.svc.getFAQ2(token,category).subscribe(res => {
          this.getFaq(res);
      });
  }

  getFaq = function(res){
	  if (res['status']==='success' && res['status_code']===200 && res['data'].length > 0) {
		  res['data'].forEach((value,index) => {
			  this.records[index] = [];
			  this.records[index]['category'] = value.category;
			  this.records[index]['qa'] = [];
			  this.categoryCount++;
			  this.questionAnswerCount[value.category] = 0;
			  this.answer[index] = [];
			  let qa = JSON.parse(value.question_answer);
			  let loop = 0;
			  for (const key in qa) {
				  this.records[index]['qa'][loop] = [key, qa[key]];
				  this.answer[index][loop] = false;
				  loop++;
				  this.questionAnswerCount[value.category]++;
			  }
		  });
		  console.log(this.records);
	  } else if (res['status']===true && res['code']==='OK' && res['data']!==undefined) {
	      let index = 0;
          for (let category in res['data']) {
              let cat = category.replace('questions', '')
              this.records[index] = [];
              this.records[index]['category'] = cat;
              this.records[index]['qa'] = [];
              this.categoryCount++;
              this.questionAnswerCount[cat] = 0;
              this.answer[index] = [];
              res['data'][category].forEach((value,key) => {
                  this.records[index]['qa'][key] = [value.question, value.answer];
                  this.answer[index][key] = false;
                  this.questionAnswerCount[cat]++;
              });
              index++;
          }
          console.log(this.records);
    }
    this.loading = false;
  }
  
  createCategory(){
	  return new Array(this.categoryCount);
  }
  createQuestionAnswer(category){
	  return new Array(this.questionAnswerCount[category]);
  }
  
  toggleAnswer(parameter1, parameter2) {
	  this.answer[parameter1][parameter2] = !this.answer[parameter1][parameter2];
  }
}
